import React from 'react'
import { Container } from './Styled'
import { Result, Button, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { RouteComponentProps } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';
import { createLoadingSelector } from '../../../business/selectors/loadingSelectors';
import Loader from '../../system/loader/Loader';
import { RootState } from '../../../model/rootReducer';
import { appInitAction } from '../../../business/actions/appActions';

const { Paragraph, Text } = Typography
interface ErrorInitProps extends RouteComponentProps {
    invoiceId?: string;
}
export const ErrorInit: React.FunctionComponent<ErrorInitProps> = props => {
    const dispatch = useDispatch();
    const loadingSelector = createLoadingSelector(['INIT_APP']);
    const isFetching = useSelector((state: RootState) => loadingSelector(state));

    return (
        <Loader isLoading={isFetching}>
            <Container>
                <Result
                    status="error"
                    title="ECHEC DE LA CONNEXION"
                    subTitle="Une erreur est survenue lors de l'initialisation de l'application, veuillez réessayer ultérieurement"
                    extra={[
                        <Button onClick={() => dispatch(appInitAction.request({}))} key="retry">Réessayer</Button>
                    ]}
                >
                    <div className="desc">
                        <Paragraph>
                            <Text
                                strong
                                style={{
                                    fontSize: 16
                                }}
                            >
                                Rapport d'erreur:
                        </Text>
                        </Paragraph>
                        <Paragraph>
                            <CloseCircleOutlined className="site-result-demo-error-icon" />{' '}
                            Impossible de se connecteur au serveur.{' '}
                        </Paragraph>
                    </div>
                </Result>
            </Container>
        </Loader>
    )
}

export default ErrorInit
